import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import KycVaraModal from "./KycVaraModal";
import { OPEN_KYC_VARA_EVENT } from "./openKycVerification";

export const KYC_VERIFICATION_PATH = "/kyc-verification";
const DASHBOARD_PATH = "/user_profile/dashboard";

/**
 * Mounted once for logged-in users. Opens the KYC modal:
 * - automatically when the URL is /kyc-verification (login, signup and the Didit return land there).
 *   Verified users see nothing.
 * - when a button calls openKycVerification(). Verified users see their "verified" status.
 */
function KycVaraModalHost({ token, userDetails }) {
  const location = useLocation();
  const navigate = useNavigate();
  // null = closed, "auto" = opened by login / signup / Didit return, "button" = opened by the user.
  const [openedBy, setOpenedBy] = useState(null);

  useEffect(() => {
    if (location.pathname !== KYC_VERIFICATION_PATH || !token) return;
    // Didit can return inside its own iframe; take over the whole window first.
    if (window.top !== window.self) {
      window.open(window.location.href, "_top");
      return;
    }
    setOpenedBy("auto");
    navigate(DASHBOARD_PATH, { replace: true });
  }, [location.pathname, token, navigate]);

  useEffect(() => {
    const openFromButton = () => setOpenedBy("button");
    window.addEventListener(OPEN_KYC_VARA_EVENT, openFromButton);
    return () => window.removeEventListener(OPEN_KYC_VARA_EVENT, openFromButton);
  }, []);

  const close = useCallback(() => setOpenedBy(null), []);

  if (!token || !openedBy) return null;
  return <KycVaraModal userDetails={userDetails} onClose={close} closeWhenVerified={openedBy === "auto"} />;
}

export default KycVaraModalHost;
